<template>
  <main id="client" class="page-container" v-if="$route.name === 'customers'">
    <!-- <p
      v-if="errorMessage"
      :class="{ 'error-message': true, show: errorMessage }"
    >
      {{ errorMessage }}
    </p>
    <p
      v-if="successMessage"
      :class="{ 'success-message': true, show: successMessage }"
    >
      {{ successMessage }}
    </p> -->
    <div class="table-container-clients">
      <div class="clients-toolbar">
        <router-link to="/home/clienti/nuovo" class="primary-btn">
          <i class="fa-solid fa-plus"></i> Nuovo cliente
        </router-link>
        <button
          class="refresh-btn"
          :class="{ refreshed }"
          @click="handleRefresh"
          :disabled="refreshing"
          title="Aggiorna"
        >
          <i
            :class="[
              'fa-solid',
              refreshed ? 'fa-check' : 'fa-arrows-rotate',
              { 'fa-spin': refreshing },
            ]"
          ></i>
          <span>{{
            refreshing ? "Aggiorna…" : refreshed ? "Aggiornato!" : "Aggiorna"
          }}</span>
        </button>
      </div>

      <div class="tbl-wrap">
        <table class="tbl client-table">
          <thead>
            <tr>
              <th id="nome-cliente">Cliente</th>
              <th id="sede">Sede</th>
              <th id="ultimo-ordine">Ultimo ordine</th>
              <th id="ultimo-preventivo">Ultimo preventivo</th>
              <th class="actions-col" style="text-align: left">Azioni</th>
            </tr>
          </thead>

          <tbody>
            <!-- due <tr> per cliente come prima -->
            <template v-for="(client, index) in allClients" :key="index">
              <tr class="client-row">
                <td>{{ client.clientName }}</td>

                <td class="address-cell">
                  <a
                    v-if="
                      client.legalHeadquarters && client.legalHeadquarters.link
                    "
                    :href="client.legalHeadquarters.link"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="custom-link"
                  >
                    {{
                      formatAddress(
                        client.legalHeadquarters.address ||
                          "Indirizzo non disponibile"
                      )
                    }}
                  </a>
                  <span v-else>{{
                    formatAddress(
                      client.legalHeadquarters?.address ||
                        "Indirizzo non disponibile"
                    )
                  }}</span>
                </td>

                <td class="date-cell">
                  <template v-if="client.lastOrder">
                    <span class="cell-main">{{
                      formatToLocalDate(client.lastOrder)
                    }}</span>
                    <span class="cell-sub">{{
                      formatToLocalDateAndHours(client.lastOrder).split(" ")[1]
                    }}</span>
                  </template>
                  <template v-else>
                    <span>Nessun ordine</span>
                  </template>
                </td>

                <td class="date-cell">
                  <template v-if="client.lastQuote">
                    <span class="cell-main">{{
                      formatToLocalDate(client.lastQuote)
                    }}</span>
                    <span class="cell-sub">{{
                      formatToLocalDateAndHours(client.lastQuote).split(" ")[1]
                    }}</span>
                  </template>
                  <template v-else>
                    <span>Nessun preventivo</span>
                  </template>
                </td>

                <td class="actions-cell">
                  <button
                    class="icons-button"
                    @click="goToEditClient(client.id)"
                    title="Modifica cliente"
                    aria-label="Modifica cliente"
                  >
                    <i class="fa-solid fa-pen-to-square"></i>
                  </button>
                  <button
                    class="icons-button"
                    @click="showSoldItems(client)"
                    title="Storico preventivi e ordini"
                    aria-label="Storico preventivi e ordini"
                  >
                    <i class="fa-solid fa-clock-rotate-left"></i>
                  </button>
                  <button
                    class="icons-button icons-button--danger"
                    @click="openArchiveModal(client)"
                    title="Archivia cliente"
                    aria-label="Archivia cliente"
                  >
                    <i class="fa-solid fa-trash-can"></i>
                  </button>
                </td>
              </tr>
            </template>
            <tr v-if="allClients.length === 0 && !isLoading">
              <td colspan="5" class="no-result">Nessun cliente trovato.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Paginazione / search -->
      <div class="pagination">
        <div class="pagination-left">
          <div class="search-container">
            <i
              v-if="!searchTerm"
              class="fa-solid fa-magnifying-glass search-icon"
            ></i>
            <input
              type="text"
              v-model="searchTerm"
              @keyup.enter="onSearch"
              placeholder="Cerca clienti..."
              class="search-box"
            />
            <button
              v-if="searchTerm"
              @click="onResetSearch"
              class="clear-search-button"
              :disabled="isLoading"
            >
              <i class="fa-solid fa-times"></i>
            </button>
          </div>
        </div>

        <div class="pagination-right">
          <div class="pagination-info">
            {{ pagination.startItem }}-{{ pagination.endItem }} di
            {{ pagination.totalItems }}
          </div>

          <div class="pagination-controls">
            <button
              class="icons-button"
              @click="goToPage(1)"
              :disabled="isLoading || pagination.currentPage === 1"
              :title="
                isLoading || pagination.currentPage === 1
                  ? null
                  : 'Torna alla prima pagina'
              "
            >
              <i class="fa-solid fa-angles-left"></i>
            </button>

            <button
              class="icons-button"
              @click="goToPage(pagination.currentPage - 1)"
              :disabled="isLoading || pagination.currentPage === 1"
              :title="
                isLoading || pagination.currentPage === 1
                  ? null
                  : 'Torna alla pagina precedente'
              "
            >
              <i class="fa-solid fa-chevron-left"></i>
            </button>

            <button
              v-for="pageNum in visiblePages"
              :key="pageNum"
              @click="goToPage(pageNum)"
              :class="{ active: pagination.currentPage === pageNum }"
              class="pages-button"
            >
              {{ pageNum }}
            </button>

            <button
              class="icons-button"
              @click="goToPage(pagination.currentPage + 1)"
              :disabled="
                isLoading || pagination.currentPage === pagination.totalPages
              "
              :title="
                isLoading || pagination.currentPage === pagination.totalPages
                  ? null
                  : 'Vai alla pagina successiva'
              "
            >
              <i class="fa-solid fa-chevron-right"></i>
            </button>

            <button
              class="icons-button"
              @click="goToPage(pagination.totalPages)"
              :disabled="
                isLoading || pagination.currentPage === pagination.totalPages
              "
              :title="
                isLoading || pagination.currentPage === pagination.totalPages
                  ? null
                  : `Vai all'ultima pagina`
              "
            >
              <i class="fa-solid fa-angles-right"></i>
            </button>
          </div>
        </div>
      </div>

      <VueFinalModal
        v-model="showItemsModal"
        :clickToClose="true"
        :escToClose="true"
        classes="documents-modal"
        content-class="client-info-modal-content"
      >
        <template #default>
          <button class="modal__close icons-button" @click="closeItemsModal">
            <i class="fa-solid fa-xmark"></i>
          </button>

          <h3 class="modal__title">Storico Preventivi e Ordini</h3>

          <!-- Filtri -->
          <div class="modal-filters">
            <div class="filter-type-group">
              <button
                :class="['filter-type-btn', { active: filterType === 'all' }]"
                @click="filterType = 'all'"
              >
                Tutti
              </button>
              <button
                :class="[
                  'filter-type-btn',
                  { active: filterType === 'preventivo' },
                ]"
                @click="filterType = 'preventivo'"
              >
                Preventivi
              </button>
              <button
                :class="[
                  'filter-type-btn',
                  { active: filterType === 'ordine' },
                ]"
                @click="filterType = 'ordine'"
              >
                Ordini
              </button>
            </div>
            <div class="filter-date-group">
              <label class="filter-date-label">
                Dal
                <FlatPickr
                  v-model="filterDateFrom"
                  :config="datePickerConfig"
                  placeholder="gg/mm/aaaa"
                  class="filter-date-input"
                />
              </label>
              <label class="filter-date-label">
                Al
                <FlatPickr
                  v-model="filterDateTo"
                  :config="datePickerConfig"
                  placeholder="gg/mm/aaaa"
                  class="filter-date-input"
                />
              </label>
              <button
                v-if="filterType !== 'all' || filterDateFrom || filterDateTo"
                class="filter-reset-btn"
                @click="resetFilters"
                title="Reimposta filtri"
              >
                <i class="fa-solid fa-times"></i>
              </button>
            </div>
          </div>

          <div class="quotes-history-list">
            <div
              v-for="group in paginatedGroups"
              :key="group.quoteId"
              class="quote-history-group"
            >
              <div class="quote-history-header">
                <span class="quote-history-date">
                  {{
                    group.isConfirmed
                      ? formatToLocalDate(group.quoteConfirmedAt)
                      : formatToLocalDate(group.quoteCreatedAt)
                  }}
                </span>
                <router-link
                  :to="
                    group.isConfirmed
                      ? `/home/ordini/dettaglio/${group.quoteId}`
                      : `/home/preventivi/dettaglio/${group.quoteId}`
                  "
                  @click="closeItemsModal"
                  class="quote-history-id"
                >
                  {{ group.isConfirmed ? "Ordine" : "Preventivo" }}
                  <strong>#{{ group.quoteId }}</strong>
                </router-link>
                <button
                  class="quote-history-toggle"
                  @click="toggleQuoteItems(group.quoteId)"
                >
                  {{ group.items.length }}
                  {{ group.items.length === 1 ? "articolo" : "articoli" }}
                  <i
                    :class="[
                      'fa-solid',
                      expandedQuoteIds[group.quoteId] === false
                        ? 'fa-chevron-down'
                        : 'fa-chevron-up',
                    ]"
                  ></i>
                </button>
              </div>

              <ul
                v-if="expandedQuoteIds[group.quoteId] !== false"
                class="quote-items-list"
              >
                <li
                  v-for="it in group.items"
                  :key="it.itemId"
                  class="quote-item-row"
                >
                  <div class="quote-item-icon">
                    <img
                      v-if="isTile(it)"
                      src="@/assets/tile.png"
                      alt=""
                      class="card-icon-img"
                    />
                    <img
                      v-else-if="isSanitary(it)"
                      src="@/assets/sanitari.png"
                      alt=""
                      class="card-icon-img"
                    />
                    <i
                      v-else
                      :class="`fa-solid ${getCategoryIcon(it)}`"
                      aria-hidden="true"
                    ></i>
                  </div>
                  <div class="quote-item-info">
                    <span class="quote-item-name">{{
                      it.name || "Articolo"
                    }}</span>
                    <span class="quote-item-meta">
                      {{ it.category }}
                      <template v-if="isTile(it) && it.mqxquantity">
                        · {{ Number(it.mqxquantity).toFixed(2) }} mq
                      </template>
                      <template v-else> · {{ it.quantity }} pz </template>
                    </span>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div v-if="!groupedQuotes.length" class="no-result">
            Nessun preventivo o ordine trovato
          </div>

          <!-- Paginazione articoli -->
          <div
            v-if="itemsPagination.totalItems > 0"
            class="pagination items-modal-pagination"
          >
            <div class="pagination-left"></div>
            <div class="pagination-right">
              <div class="pagination-info">
                {{ itemsPagination.startItem }}–{{ itemsPagination.endItem }} di
                {{ itemsPagination.totalItems }}
              </div>
              <div
                v-if="itemsPagination.totalPages > 1"
                class="pagination-controls"
              >
                <button
                  class="icons-button"
                  @click="itemsPage = 1"
                  :disabled="itemsPagination.currentPage === 1"
                >
                  <i class="fa-solid fa-angles-left"></i>
                </button>
                <button
                  class="icons-button"
                  @click="itemsPage = itemsPagination.currentPage - 1"
                  :disabled="itemsPagination.currentPage === 1"
                >
                  <i class="fa-solid fa-chevron-left"></i>
                </button>
                <button
                  v-for="pageNum in visibleItemPages"
                  :key="pageNum"
                  @click="itemsPage = pageNum"
                  :class="{ active: itemsPagination.currentPage === pageNum }"
                  class="pages-button"
                >
                  {{ pageNum }}
                </button>
                <button
                  class="icons-button"
                  @click="itemsPage = itemsPagination.currentPage + 1"
                  :disabled="
                    itemsPagination.currentPage === itemsPagination.totalPages
                  "
                >
                  <i class="fa-solid fa-chevron-right"></i>
                </button>
                <button
                  class="icons-button"
                  @click="itemsPage = itemsPagination.totalPages"
                  :disabled="
                    itemsPagination.currentPage === itemsPagination.totalPages
                  "
                >
                  <i class="fa-solid fa-angles-right"></i>
                </button>
              </div>
            </div>
          </div>
        </template>
      </VueFinalModal>

      <VueFinalModal
        v-model="showArchiveModal"
        :clickToClose="!archiving"
        :escToClose="!archiving"
        classes="documents-modal"
        content-class="confirm-modal-content modal--archive"
      >
        <template #default>
          <button
            class="modal__close icons-button"
            @click="closeArchiveModal"
            :disabled="archiving"
            title="Chiudi"
            aria-label="Chiudi"
          >
            <i class="fa-solid fa-xmark"></i>
          </button>

          <h3 class="modal__title">Archivia cliente</h3>
          <p class="modal__subtitle">
            Sei sicuro di voler archiviare
            <strong>{{ selectedClient?.clientName }}</strong
            >?
          </p>

          <div class="modal-actions">
            <button
              class="secondary-btn"
              @click="closeArchiveModal"
              :disabled="archiving"
            >
              Annulla
            </button>
            <button
              class="primary-btn confirm-btn"
              @click="confirmArchive"
              :disabled="archiving"
            >
              <span v-if="archiving">Archivia…</span>
              <span v-else>Archivia</span>
            </button>
          </div>
        </template>
      </VueFinalModal>
    </div>
  </main>
  <router-view></router-view>
</template>

<script>
import { mapActions, mapGetters } from "vuex/dist/vuex.cjs.js";
import {
  formatToLocalDate,
  formatToLocalDateAndHours,
} from "../utilities/formatting";
import FlatPickr from "vue-flatpickr-component";
import { Italian } from "flatpickr/dist/l10n/it.js";

export default {
  components: { FlatPickr },
  computed: {
    ...mapGetters({
      allClients: "clients/list",
      pagination: "clients/pagination",
    }),

    visiblePages() {
      const range = 2;
      const start = Math.max(1, this.pagination.currentPage - range);
      const end = Math.min(
        this.pagination.totalPages,
        this.pagination.currentPage + range
      );
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },

    /* filtro live sugli articoli */
    filteredItems() {
      const q = (this.itemSearch || "").toLowerCase().trim();
      const type = this.filterType;
      const from = this.filterDateFrom
        ? new Date(this.filterDateFrom + "T00:00:00")
        : null;
      const to = this.filterDateTo
        ? new Date(this.filterDateTo + "T23:59:59")
        : null;

      return this.soldItems.filter((it) => {
        if (
          q &&
          ![it.name, it.category]
            .filter(Boolean)
            .join(" ")
            .toLowerCase()
            .includes(q)
        )
          return false;
        if (type === "ordine" && !it.isConfirmed) return false;
        if (type === "preventivo" && it.isConfirmed) return false;
        if (from || to) {
          const dateStr = it.isConfirmed
            ? it.quoteConfirmedAt
            : it.quoteCreatedAt;
          const date = dateStr ? new Date(dateStr) : null;
          if (!date) return false;
          if (from && date < from) return false;
          if (to && date > to) return false;
        }
        return true;
      });
    },

    groupedQuotes() {
      const map = {};
      for (const it of this.filteredItems) {
        const id = it.quoteId;
        if (!map[id]) {
          map[id] = {
            quoteId: id,
            isConfirmed: it.isConfirmed,
            quoteCreatedAt: it.quoteCreatedAt,
            quoteConfirmedAt: it.quoteConfirmedAt,
            items: [],
          };
        }
        map[id].items.push(it);
      }
      return Object.values(map).sort((a, b) => b.quoteId - a.quoteId);
    },

    itemsPagination() {
      const total = this.groupedQuotes.length;
      const totalPages = Math.ceil(total / this.itemsPerPage) || 1;
      const currentPage = Math.min(this.itemsPage, totalPages);
      return {
        currentPage,
        totalPages,
        totalItems: total,
        startItem: total === 0 ? 0 : (currentPage - 1) * this.itemsPerPage + 1,
        endItem: Math.min(currentPage * this.itemsPerPage, total),
      };
    },

    paginatedGroups() {
      const { currentPage } = this.itemsPagination;
      const start = (currentPage - 1) * this.itemsPerPage;
      return this.groupedQuotes.slice(start, start + this.itemsPerPage);
    },

    visibleItemPages() {
      const range = 2;
      const { currentPage, totalPages } = this.itemsPagination;
      const start = Math.max(1, currentPage - range);
      const end = Math.min(totalPages, currentPage + range);
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
  },
  data() {
    return {
      // clients: [],
      errorMessage: "",
      successMessage: "",
      isLoading: false,
      refreshing: false,
      refreshed: false,
      searchTerm: "",

      /* ===  MODAL Articoli  === */
      showItemsModal: false,
      soldItems: [],
      itemSearch: "",
      itemsPage: 1,
      itemsPerPage: 4,
      filterType: "all",
      filterDateFrom: "",
      filterDateTo: "",
      datePickerConfig: {
        locale: Italian,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: "d/m/Y",
        allowInput: true,
        monthSelectorType: "static",
      },
      showArchiveModal: false,
      archiving: false,
      selectedClient: null,
      expandedQuoteIds: {},
    };
  },
  methods: {
    ...mapActions(["fetchClients", "archiveClient", "fetchClientSoldItems"]),

    async handleRefresh() {
      this.refreshing = true;
      this.refreshed = false;
      try {
        await this.getClients(this.pagination.currentPage);
      } finally {
        this.refreshing = false;
        this.refreshed = true;
        setTimeout(() => {
          this.refreshed = false;
        }, 1500);
      }
    },

    itemKeyStable(it) {
      return (
        it.id ??
        it.itemId ??
        it.code ??
        `${it.category || "x"}-${
          it.name || it.brand || it.itemName || it.subBrand || "unk"
        }`
      );
    },

    isTile(it) {
      const c = (it.category || "").toLowerCase();
      return c.includes("piastrelle") || c.includes("piastrella");
    },
    isSanitary(it) {
      const c = (it.category || "").toLowerCase();
      return c.includes("sanitari") || c.includes("sanitario");
    },
    getCategoryIcon(it) {
      const c = (it.category || "").toLowerCase();
      if (c.includes("rubinetteria")) return "fa-faucet";
      if (c.includes("box doccia")) return "fa-shower";
      if (c.includes("accessori bagno")) return "fa-bath";
      if (c.includes("parquet") || c.includes("laminati"))
        return "fa-chess-board";
      if (c.includes("rivestimenti")) return "fa-layer-group";
      if (c.includes("decking")) return "fa-border-all";
      if (c.includes("profili")) return "fa-ruler-horizontal";
      if (c.includes("scarico")) return "fa-water";
      if (c.includes("mobili")) return "fa-couch";
      if (c.includes("porte") || c.includes("infissi")) return "fa-door-open";
      return "fa-box-open";
    },

    /* etichetta quantità in mq o pezzi */
    getItemLabel(item) {
      return this.isTile(item) && item.mqxquantity
        ? "Quantità al mq: "
        : "Quantità: ";
    },

    /* apre il modal, carica gli articoli */
    async showSoldItems(client) {
      try {
        this.itemsPage = 1;
        this.showItemsModal = true;
        //  ► chiedi gli articoli al backend / store
        const resp = await this.fetchClientSoldItems(client.id);
        //  ► salva nello stato locale
        this.soldItems = resp.items;
      } catch (e) {
        // console.error(e);
        this.errorMessage =
          "Impossibile caricare gli articoli di questo cliente.";
        this.$toast.error(this.errorMessage);
      }
    },

    resetFilters() {
      this.filterType = "all";
      this.filterDateFrom = "";
      this.filterDateTo = "";
      this.itemsPage = 1;
    },

    closeItemsModal() {
      this.showItemsModal = false;
      this.soldItems = [];
      this.itemSearch = "";
      this.itemsPage = 1;
      this.expandedQuoteIds = {};
      this.resetFilters();
    },

    toggleQuoteItems(quoteId) {
      if (this.expandedQuoteIds[quoteId] === false) {
        delete this.expandedQuoteIds[quoteId];
      } else {
        this.expandedQuoteIds[quoteId] = false;
      }
    },

    openArchiveModal(client) {
      this.selectedClient = client;
      this.showArchiveModal = true;
    },

    closeArchiveModal() {
      if (this.archiving) return; // evita chiusure durante la richiesta
      this.showArchiveModal = false;
      this.selectedClient = null;
    },

    formatToLocalDate,
    formatToLocalDateAndHours,

    formatAddress(address) {
      if (!address) return "Indirizzo non disponibile";
      const withCap = address.replace(/,?\s+(\d{5}\s)/, "\n$1");
      if (withCap !== address) return withCap;
      return address.replace(/,\s*/, ",\n");
    },

    async getClients(page = 1, search = this.searchTerm) {
      this.isLoading = true;
      try {
        const res = await this.fetchClients({ page, limit: 8, search });
        return res;
      } catch (error) {
        if (error?.response?.status === 404 && page !== 1) {
          // se la pagina richiesta non ha risultati, riprova la prima
          try {
            await this.fetchClients({
              page: 1,
              limit: 8,
              search,
            });
            this.pagination.currentPage = 1;
            return;
          } catch (_) {
            /* ignora, gestiamo sotto */
          }
        }

        // messaggio come per i preventivi, ma per i clienti
        if (error?.response?.status !== 404) {
          this.$nextTick(() => {
            this.errorMessage =
              error?.response?.data?.message ||
              error?.response?.data?.details ||
              "Errore nel caricamento dei clienti.";
            this.$toast.error(this.errorMessage);
          });
        }
      } finally {
        this.isLoading = false;
      }
    },

    goToPage(page) {
      if (page < 1 || page > this.pagination.totalPages) return;
      this.getClients(page);
    },

    async onSearch() {
      this.isLoading = true;
      try {
        await this.getClients(1, this.searchTerm);
        // if (Array.isArray(res) && res.length === 0) {
        //   this.$toast.error("Nessun cliente per la ricerca richiesta.");
        // }
      } catch (err) {
        if (err?.response?.status !== 404) {
          const msg =
            err?.response?.data?.message ||
            err?.response?.data?.details ||
            "Errore nel caricamento dei clienti.";
          this.$toast.error(msg);
        }
      } finally {
        this.isLoading = false;
      }
    },

    async onResetSearch() {
      this.isLoading = true;
      try {
        this.searchTerm = "";
        await this.getClients(1, "");
      } catch {
        this.errorMessage = "Errore durante il reset della ricerca.";
        this.$toast.error(this.errorMessage);
      } finally {
        this.isLoading = false;
      }
    },

    goToEditClient(clientId) {
      this.$router.push({ name: "edit-client", params: { clientId } });
    },

    // async onArchiveClient(clientId) {
    //   // Logica per conferma e chiamata API
    //   const conferma = window.confirm(
    //     "Sei sicuro di voler archiviare il cliente?"
    //   );
    //   if (!conferma) return;

    //   try {
    //     await this.archiveClient(clientId);
    //     this.successMessage = "Cliente archiviato con successo.";
    //   } catch (err) {
    //     console.error(err);
    //     this.errorMessage = "Impossibile archiviare il cliente.";
    //   }
    // },

    async confirmArchive() {
      if (!this.selectedClient) return;
      try {
        this.archiving = true;
        // se la tua action accetta solo l'id, basta passare quello.
        await this.archiveClient(this.selectedClient.id);

        this.successMessage = "Cliente archiviato con successo.";
        this.$toast.success(this.successMessage);
        this.showArchiveModal = false;

        // ricarica lista per riflettere lo stato
        this.getClients(1);
      } catch (err) {
        console.error(err);
        this.errorMessage = "Impossibile archiviare il cliente.";
        this.$toast.error(this.errorMessage);
      } finally {
        this.archiving = false;
      }
    },
  },

  watch: {
    $route(to, from) {
      if (to.name === "customers" && from.name !== "customers") {
        this.getClients(1);
      }
    },
    searchTerm() {
      this.onSearch();
    },
    itemSearch() {
      this.itemsPage = 1;
    },
    filterType() {
      this.itemsPage = 1;
    },
    filterDateFrom() {
      this.itemsPage = 1;
    },
    filterDateTo() {
      this.itemsPage = 1;
    },
  },
  mounted() {
    this.getClients(1);
  },
};
</script>

<style src="@/css/ClientPage.css" />
